import React from 'react';
import { ta } from '../../i18n/adminT';

// Interruttore on/off. Usa un pulsante con role="switch", quindi funziona
// con tastiera (Invio/Spazio) e con gli screen reader.
export default function Switch({ checked, onChange, disabled, label, onText = 'Sì', offText = 'No' }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      className={`switch ${checked ? 'switch--on' : ''}`}
      onClick={() => onChange(!checked)}
    >
      <span className="switch__track" aria-hidden="true">
        <span className="switch__thumb" />
      </span>
      <span className="switch__label">{ta(checked ? onText : offText)}</span>
    </button>
  );
}
